// ABOUTME: The hook the Jobs page's feed renders from once PRO_LISTING_FEED is on: the sections this app knows, in
// ABOUTME: pro-core's order, with "the feed is off for this talent" kept apart from a failure.
import { useMemo } from 'react';
import { ApiError } from 'utils/api';
import { FEED_UNAVAILABLE_ERROR_CODE, JOBS_FEED_TAB } from './constants';
import { useFeedQuery } from './query';
import { FeedSection } from './types';
import { knownSections } from './utils';

export interface FeedState {
  sections: FeedSection[] | undefined;
  isLoading: boolean;
  isError: boolean;
  /** pro-core answered 404: the feed is off for this talent on its side. The page falls back to today's. */
  isUnavailable: boolean;
}

/** Mounted only behind PRO_LISTING_FEED (see JobsFeed), so with the flag off nothing of it runs. */
export const useFeed = (): FeedState => {
  const { data, isIdle, isLoading, isError, error } = useFeedQuery(
    JOBS_FEED_TAB,
    true
  );
  const sections = useMemo(
    () => (data ? knownSections(data.sections) : undefined),
    [data]
  );
  const isUnavailable =
    isError &&
    error instanceof ApiError &&
    error.code === FEED_UNAVAILABLE_ERROR_CODE;

  return {
    sections,
    // Idle means the query is waiting for the Auth0 token: still loading as far as the page is concerned.
    isLoading: isLoading || isIdle,
    isError: isError && !isUnavailable,
    isUnavailable
  };
};
